import React, { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import { TextIconButtonComponent } from "../../../../component/atom";
import { useQuizForm } from "../../../../hook/useQuizForm";
import QuizFormBody from "../../../../component/molecule/Cards/admin/QuizFormBody";
import { useQuizFolders } from "../../../../hook/useQuizFolders";
import { useActiveQuizData, DOCUMENT_STATUS } from "../../../../core/Constant";

const AdminQuizEditFirstScreen = ({ getQuizById}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const quizid = location.state?.id;
  const locationQuizData = location.state?.quizData;

  const { folders, loadingFolders } = useQuizFolders();

  const commonCourseList = useSelector((state) =>
      state.course?.get("allStatusCourseList") ||
      state.students?.get("commonCourseList") ||
      []
  );

  useEffect(() => {
    dispatch(Actions.course.getAllStateCourseList());
  }, [dispatch]);

  const reduxQuizData = useSelector((state) => state.quizes?.get?.("quizData") || state.quizes?.quizData);

  useEffect(() => {
    if (quizid) getQuizById(quizid);
  }, [quizid, getQuizById]);

  const { baseUrl, activeQuizData } = useActiveQuizData(
    reduxQuizData,
    locationQuizData,
    location.state
  );

  const form = useQuizForm(activeQuizData);

  const handleSave = () => {
    if (form.validateForm ? form.validateForm() : true) {
      const fd = new FormData();
      fd.append("quiz_id", quizid);
      fd.append("name", form.name);
      fd.append("description", form.description);
      fd.append("duration", form.time);
      fd.append("no_of_attempts", form.noAttempt);
      fd.append("week", "3");

      if (Array.isArray(form.selectedFolderIds)) {
        form.selectedFolderIds.forEach((id, index) => {
          fd.append(`directory_ids[${index}]`, id);
        });
      }

      if (Array.isArray(form.selectedCourses)) {
        form.selectedCourses.forEach((id, index) => {
          fd.append(`course_ids[${index}]`, id);
        });
      }

      if (form.thumbnail instanceof File) {
        fd.append("thumbnail", form.thumbnail);
      }

      if (form.thumbnail instanceof File) {
      fd.append("thumbnail", form.thumbnail);
      fd.append("delete_thumbnail", DOCUMENT_STATUS.INACTIVE); 
    } else if (form.thumbnailRemoved || form.deleteThumbnail) {
      fd.append("delete_thumbnail", DOCUMENT_STATUS.ACTIVE); 
    } else {
      fd.append("delete_thumbnail", DOCUMENT_STATUS.INACTIVE); 
      }

      dispatch(Actions.quizes.updateQuiz(fd));
    }
  };

  return (
      <Box className="main-screen-container">
        <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
          <Grid item>
            <HeadingComponent
              text={"Edit Quiz"}
              fontweigth={600}
              size={40}
              backNavigation={true}
              fontfamily={"Montserrat"}
            />
          </Grid>
          <Grid item>
          <Box display="flex" gap={2}>
            <button
              type="button"
              style={{
                padding: "10px 24px",
                border: "1px solid #D9DCE3",
                borderRadius: 8,
                background: "#fff",
                cursor: "pointer",
              }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <TextIconButtonComponent
              btnText="Save & Next"
              onclick={handleSave}
            />
            </Box>
          </Grid>
        </Grid>

      {/* Quiz Form Body */}
      <QuizFormBody
        form={form}
        folderItems={folders}
        loadingFolders={loadingFolders}
        courseList={commonCourseList}
        baseUrl={baseUrl}
      />

      <Grid mt={5} container justifyContent="flex-end">
        <Box display="flex" gap={2}>
          <button
            type="button"
            style={{
              padding: "10px 24px",
              border: "1px solid #D9DCE3",
              borderRadius: 8,
              background: "#fff",
              cursor: "pointer",
            }}
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
                <TextIconButtonComponent
                  btnText={"Save & Next"}
                  onclick={handleSave}
                />
        </Box>
      </Grid>
      </Box>
  );
};

export default connect(null, {
    getQuizById: Actions.quizes.getQuizById,
})(AdminQuizEditFirstScreen);